import { defineMessages } from 'react-intl';

export default defineMessages({
	message1: {
		id: 'notFound.message1',
		defaultMessage: 'Take a deep breath... the page you’re looking for can’t be found.',
		description: 'A calming message to see when the 404 page is shown',
	},
	message2: {
		id: 'notFound.message2',
		defaultMessage: 'Head back to find your calm.',
		description: 'An invitation to go back to the homepage when the 404 page is shown',
	},
	title: {
		id: 'notFound.title',
		defaultMessage: '404',
		description: "The error code shown when a page can't be found.",
	},
	cta: {
		id: 'notFound.cta',
		defaultMessage: 'Home',
		description: 'A link to go back to the homepage',
	},
});
